import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, QueryList } from '@angular/core';
import { DOData, NJDocData, NJDocDefTemplate, componentVM } from '../DOData';
import { DocDefPrimLibService } from '../../doc-def-prim-lib.service';
import { DobuttonComponent } from '../dobutton/dobutton.component';
@Component({
    selector: 'cylib-section-accordion',
    //https://github.com/twbs/bootstrap/issues/22114
    templateUrl: './section-accordion.component.html',
    styleUrls: ['./section-accordion.component.css']
})
export class SectionAccordionComponent implements OnInit {
    @Input() public loaderKey: string;
    //#region accordionVM
    private _accordionVM: Array<Array<DOData>>;
    @Input() public set accordionVM(AccordionVM: Array<Array<DOData>>) {
        if (AccordionVM) {
            this._accordionVM = AccordionVM;
            this.InitAccordionState();
        }
    }
    //#endregion End accordionVM
    isHidden: boolean;
    @Input() customParameters: any
    @ViewChildren(DobuttonComponent) ButtonComponents: QueryList<DobuttonComponent>;
    @Output() section_tableAfterViewInit: EventEmitter<SectionAccordionComponent> = new EventEmitter<SectionAccordionComponent>();
    //#region events
    @Output() clickBut: EventEmitter<DOData> =
        new EventEmitter<DOData>();
    @Output() tabEvent: EventEmitter<componentVM> =
        new EventEmitter<componentVM>();
    @Output() requestRows: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    public get accordionVM(): Array<Array<DOData>> {
        return this._accordionVM;
    }
    //#endregion events
    private AccordionsOpen = new Array<boolean>();
    accClass: string = "";

    constructor(private data: DocDefPrimLibService) { }
    ngOnInit() {
        this._accordionVM = new Array<Array<DOData>>();
    }
    public getAccordionsVM(): Array<number> {
        let ret: Array<number> = new Array<number>();
        for (let i: number = 0; i < this.accordionVM.length; i++) {
            ret.push(i);
        }
        return ret;
    }
    public getAccordionContentVM(acc: number): Array<DOData> {
        //let ret = this.accordionVM[acc];
        //return ret;
        return this.performFilterRow(this.accordionVM[acc]);
    }
    performFilterRow(row: Array<DOData>): Array<DOData> {
        return row.filter((d: DOData) => {
            return (d.customParameters['Composite'] == null)
        })
    }

    getTemplateCodeAccordion(acc: string): string {
        return "ID"+this.accordionVM[acc][0].njDocDefTemplate.docDefTemplateID.toString();
    }
    getTemplateAccordion(acc: string): NJDocDefTemplate {
        return this.accordionVM[acc][0].njDocDefTemplate;
    }
    getTemplateSectionCode(): string {
        if (this.accordionVM.length == 0)
            return '0'
        else
            return this.accordionVM[0][0].njDocDefTemplate.docDefSecId.toString();
    }

    InitAccordionState() {
        for (let i: number = 0; i < this.accordionVM.length; i++) {
            this.AccordionsOpen.push(i == 0);
        }
        this.onclickBut(this.accordionVM[0][0]);
    }
    getCollapse(acc: number) {
        let ret: string = "";
        // if (acc == 0)
        //     ret = "collapse show";
        // else
            ret = "collapse";
        return ret;
    }
    getAccordionHeaderClass(acc: number, cardClass: string) {
        if (this.accordionVM[acc][0].customParameters['Class'] === null)
            return cardClass;
        else
            return "";
    }
    getAccordionClasses(acc: number, classes: string): string {
        let allClasses: string = "card-link d-block"
        if (this.accordionVM[acc][0].customParameters['Class'] != null)
            allClasses += " " + this.accordionVM[acc][0].customParameters['Class'];
        return allClasses;
    }
    /*
    getAccordionClass(acc: number): string {
        let ret: string = "";
        let strClass: string = "";
        if (this.AccordionsOpen[acc])
            strClass = "show";
        else
            strClass = "collapse";
        if (this.accordionVM[acc][0].customParameters['Class'] == null) {
            ret = strClass;
        } else {
            ret = this.accordionVM[acc][0].customParameters['Class'] +" "+ strClass;
        }
        return ret
    }
    */
    setHiddenStatus(acc: number) {
        let accordion = this.accordionVM[acc][0];
        if (accordion.customParameters.Hidden == 'Yes')
            this.isHidden = true;
        //is the the required seccode in the user's credentials
        else if (this.customParameters["HiddenIfMissingSecCode"]) {
            this.data.checkIfCodeInUserSecurity(accordion.customParameters["HiddenIfMissingSecCode"], this.data.LoaderKey).subscribe((ret: boolean) => {
                if (ret) {
                    this.isHidden = false;
                }
                else {
                    this.isHidden = true;
                }
            });
        }
        else this.isHidden = false;
    }
    getAccordionStyle(acc: number): object { 
        let accordion = this.accordionVM[acc][0];
        if (accordion.customParameters['Styles'] == null) {
         return {};
        } else {
            let styles = this.data.replaceAll(accordion.customParameters['Styles'], "'", '"');
            return JSON.parse(styles);
        }
    }
    opened(acc: number) {
        for (let i: number = 0; i < this.accordionVM.length; i++) {
            if (acc==i)
                this.AccordionsOpen[acc] = !this.AccordionsOpen[acc] ;
            else
                this.AccordionsOpen[i] = (acc == i)
        }
        this.onclickBut(this.accordionVM[acc][0]);
        //this.AccordionsOpen
    }
    //#region events
    onTabEvent(message: componentVM) {
        this.tabEvent.emit(message);
    }
    onclickBut(message: DOData) {
        this.ButtonComponents.forEach((but: DobuttonComponent) => {
            if (but.DocDefTemplate.templateCode != message.njDocDefTemplate.templateCode)
                but.resetButClass();
        });
        this.clickBut.emit(message);
    }
    onRequestRows(message: boolean) {
        this.requestRows.emit(message);
    }
    ngAfterViewInit() {
        this.section_tableAfterViewInit.emit(this);
    }
    public getPrimitives(): Array<DOData> {
        let lstDoData: Array<DOData> = new Array<DOData>();
        this.ButtonComponents.forEach((TextBox: DobuttonComponent) => {
            let DoDOData: DOData = new DOData();
            DoDOData.njDocData = TextBox.DocData;
            DoDOData.customParameters = TextBox.customParameters;
            DoDOData.njDocDefTemplate = TextBox.DocDefTemplate;
            lstDoData.push(DoDOData);
        });
        
        return lstDoData;
    }
    //#endregion events
}
